import React, { useState } from "react";
import DaterangePicker from "../../common/Daterangepicker";
import { useSelector } from "react-redux";
import bookingananalytics from "../../assets/booking-analytics.png";
import citywisetable from "../../assets/citywisetable.png";
import Kpianalytics from "./KPI'sanalytics";
import Bookingoverview from "./Bookingoverview";
import Citywisetable from "./Citywisetable";
import ComingSoon from "../../common/ComingSoon";
import Modifications from "./Modifications";
import Availability from "./Availability";
import Deliveryandpickups from "./Deliveryandpickups";
import Refunds from "./Refunds";

const Bookinganalytics = () => {
  const [activeTab, setActiveTab] = useState("KPIs");

  const tabs = [
    "KPIs",
    "Bookings Overview",
    "Modifications",
    "Availability",
    "Delivery & Pickups",
    "Refunds",
    "Inquiries",
    "Customer Sign-ups",
  ];

  const tabContent = {
    KPIs: (
      <div>
        <Kpianalytics />
      </div>
    ),
    "Bookings Overview": (
      <div>
        <ComingSoon />
      </div>
    ),
    Modifications: (
      <div>
        <ComingSoon />
      </div>
    ),
    Availability: (
      <div>
        <ComingSoon />
      </div>
    ),
    "Delivery & Pickups": (
      <div>
        <ComingSoon />
      </div>
    ),
    Refunds: (
      <div>
        <ComingSoon />
      </div>
    ),
    Inquiries: (
      <div>
        <ComingSoon />
      </div>
    ),
    "Customer Sign-ups": (
      <div>
        <ComingSoon />
      </div>
    ),
    "City wise table": (
      <>
        <Citywisetable />
      </>
    ),
    Analytics: (
      <>
        <ComingSoon />
      </>
    ),
  };

  return (
    <div>
      <div className="text-2xl font-semibold mt-6">Booking Analytics</div>
      <div className="w-full my-4 inline-flex items-center gap-4 text-Outfit">
        <div className="flex-1 h-12 p-1 bg-gray-50 rounded-2xl border border-gray-100 flex items-start gap-2">
          {tabs.map((tab) => (
            <div
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`flex-1 min-w-max h-9 relative rounded-[10px] shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10)] shadow-[0px_1px_3px_0px_rgba(0,0,0,0.10)] cursor-pointer flex items-center justify-center px-4 transition-all
              ${
                activeTab === tab
                  ? "bg-blue-700 text-white"
                  : "bg-white text-black"
              }`}
            >
              <span className="text-sm font-semibold leading-5 whitespace-nowrap">
                {tab}
              </span>
              {activeTab === tab && (
                <div
                  className="absolute left-1/2 -translate-x-1/2 -bottom-2 w-0 h-0
                     border-l-[18px] border-l-transparent
                     border-r-[18px] border-r-transparent
                     border-t-[12px] border-t-blue-700"
                />
              )}
            </div>
          ))}
        </div>

        <div
          onClick={() => {
            setActiveTab("City wise table");
          }}
          className={`w-12 h-12 rounded-[10px] shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10)] shadow-[0px_1px_3px_0px_rgba(0,0,0,0.10)] border border-gray-200 ${activeTab === "City wise table" ? "bg-blue-500" : "bg-black"} hover:bg-blue-500 flex justify-center items-center cursor-pointer`}
        >
          <img className="w-8 h-8" src={citywisetable} />
        </div>

        <div
          onClick={() => {
            setActiveTab("Analytics");
          }}
          className="w-12 h-12 bg-white rounded-[10px] shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10)] shadow-[0px_1px_3px_0px_rgba(0,0,0,0.10)] border border-gray-200 flex justify-center items-center cursor-pointer"
        >
          <img src={bookingananalytics} />
        </div>
      </div>
      <div className="mt-6 bg-white">{tabContent[activeTab]}</div>
    </div>
  );
};

export default Bookinganalytics;
